module.exports = __webpack_public_path__ + "media/images/bau-digital-logo-5e5b3a62.png";